'use client'

import parse from 'html-react-parser'

const InfoItem = ({ header = '', subheader = '', className = '' }) => {
  return (
    <div
      className={`col-xl-6 col-12 custom-column-2 d-flex align-items-start ${className}`}
      style={{ borderWidth: '0px', margin: '0px' }}
    >
      <i
        className="bi bi-check-circle"
        style={{ fontSize: '25px', paddingRight: '20px', color: '#221AFB' }}
      ></i>
      <div>
        {header && <div className="column-header-2">{parse(header)}</div>}
        {subheader && <div className="column-subheader-2">{parse(subheader)}</div>}
      </div>
    </div>
  )
}

export default InfoItem
